import { ComponentType } from 'react';

export function getDisplayName(Cmp: React.ComponentType<any>) {
  return Cmp.displayName || Cmp.name || 'Component';
}

export const withDefaultProps = <P extends object, DP extends Partial<P> = Partial<P>>(
  defaultProps: DP,
  Cmp: ComponentType<P>
) => {
  type RequiredProps = Omit<P, keyof DP>;
  type Props = Partial<DP> & Required<RequiredProps>;
  Cmp.defaultProps = defaultProps;
  // fixme: 颜色主题问题
  Cmp.displayName = `withDefaultProps(${getDisplayName(Cmp)})`;
  return (Cmp as ComponentType<any>) as ComponentType<Props>;
};
